<template>
  <dev-placeholder/>
</template>

<script>
import DevPlaceholder from '../../../helpers/TheDevPlaceholder'
export default {
  name: 'target-file',
  components: {
    DevPlaceholder
  }
}
</script>
